export function initGA() {
  try {
    const id = (import.meta as any).env?.VITE_GA_TRACKING_ID as string | undefined;
    if (!id) return; // analytics disabled if not configured

    // Only enable in production and on the configured host (if provided)
    if (!import.meta.env.PROD) return;
    // Require consent
    try {
      const consent = localStorage.getItem('analytics_consent');
      if (consent !== 'accepted') return;
    } catch {}
    const appUrl = (import.meta as any).env?.VITE_APP_URL as string | undefined;
    if (appUrl) {
      try {
        const allowed = new URL(appUrl).hostname;
        if (location.hostname !== allowed) return;
      } catch { /* ignore URL parse errors */ }
    }

    // Inject gtag script
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(s);

    // Init gtag
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(){ (window as any).dataLayer.push(arguments); }
    (window as any).gtag = gtag;
    gtag('js', new Date());
    // Basic privacy: anonymize IP
    gtag('config', id, { anonymize_ip: true });
  } catch (e) {
    // Fail silently
    if (import.meta.env.DEV) console.warn('GA init failed:', e);
  }
}
